var render = function render(){var _vm=this,_c=_vm._self._c;return _c('face-rule',{attrs:{"show-cancel":_vm.showCancel !== 'notice'},on:{"agree":_vm.handleAgree}})
}
var staticRenderFns = []

export { render, staticRenderFns }